import { FC, ReactNode } from 'react';
import { PageHeader } from './PageHeader';

interface PageWrapperProps {
    title: string;
    subtitle?: string;
    headerActions?: ReactNode;
    tabs?: ReactNode;
    children: ReactNode;
    className?: string;
    containerClassName?: string;
    hideHeader?: boolean;
}

/**
 * PageWrapper Component
 * Standardizes the layout for all top-level pages with a consistent header and content area
 */
export const PageWrapper: FC<PageWrapperProps> = ({
    title,
    subtitle,
    headerActions,
    tabs,
    children,
    className = "",
    containerClassName = "p-6 md:p-8",
    hideHeader = false
}) => {
    return (
        <div className={`min-h-screen bg-gray-50 flex flex-col ${className}`}>
            {!hideHeader && (
                <PageHeader title={title} subtitle={subtitle} tabs={tabs}>
                    {headerActions}
                </PageHeader>
            )}
            <main className={`flex-1 ${containerClassName}`}>
                {children}
            </main>
        </div>
    );
};
